import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useConfig } from '../../../../config/ConfigProvider';
import { processPaymentAuthorisation } from '../../../../services/retryPaymentService';
import ActionCreator from '../../../Adyen/Authorization/ActionCreator';
import { useAppContext } from '../../../AppContextProvider';
import BaseModal from '../../../Overlays/Modals/BaseModal';
import { OverlayIds, useOverlays } from '../../../OverlaysProvider';
import { useThunkDispatch } from '../../../providers/ThunkDispatchProvider';
import { useRetryState } from '../../RetryDataProvider';

const BancontactMobileAuthActionModal: React.FC = () => {
  const {
    config: {
      env,
      adyen: { clientKey },
    },
  } = useConfig();
  const { t } = useTranslation();
  const { hideOverlay } = useOverlays();
  const { locale, shopBundle } = useAppContext();
  const {
    retryState: { initiatePaymentData, customerId, processAuthorisationData },
  } = useRetryState();
  const { thunkDispatch } = useThunkDispatch();
  const retryPaymentStatus = processAuthorisationData?.authorizationResult?.retryPaymentStatus;

  const overlayId = OverlayIds.BANCONTACT_MOBILE_AUTH;
  const handlePaymentDetails = useCallback(
    (payload: string) => {
      thunkDispatch(
        processPaymentAuthorisation({
          customerId: String(customerId),
          paymentId: initiatePaymentData?.paymentId,
          paymentMethod: 'BANCONTACT_MOBILE',
          payload: payload,
        }),
      );
    },
    [customerId, initiatePaymentData?.paymentId],
  );

  const actionTimedOutHandler = useCallback(() => {
    hideOverlay(overlayId);
  }, [hideOverlay, overlayId]);

  useEffect(() => {
    if (retryPaymentStatus === 'SUCCESSFUL') hideOverlay(overlayId);
  }, [hideOverlay, overlayId, retryPaymentStatus]);

  return initiatePaymentData?.actionObject ? (
    <BaseModal
      modalId={overlayId}
      heading={t('mzp.order.detail.retry.payment.qrcode.info')}
      headingId="bankcontact-mobile-modal"
      closeBtnAriaLabel="Close"
      dataZta="modal-bankContantMobile"
      size="md">
      <ActionCreator
        paymentAction={initiatePaymentData?.actionObject}
        clientKey={clientKey}
        adyenEnvironment={env === 'prod' ? 'live' : 'test'}
        locale={locale}
        shopBundle={shopBundle}
        sendPaymentDetailsHandler={handlePaymentDetails}
        actionTimedOutHandler={actionTimedOutHandler}
        invalidQRCodeActionShopUrl={'#'}
      />
    </BaseModal>
  ) : null;
};

export default BancontactMobileAuthActionModal;
